import { defineMessage, defineMessages } from 'react-intl';

export const hasImageURLFilterOptions = {
  hasURL: defineMessage({
    defaultMessage: 'Has Image URL',
    id: 'AdVQsE',
    description: 'Filter Options Has Image URL',
  }),
  noURL: defineMessage({
    defaultMessage: 'No Image URL',
    id: 'SrH7Yw',
    description: 'Filter Options No Image URL',
  }),
};

export const isBundleFilterOptions = {
  isBundle: defineMessage({
    defaultMessage: 'Is Bundle',
    id: 'FmzjJI',
    description: 'Filter Options Is Bundle',
  }),
  isNotBundle: defineMessage({
    defaultMessage: 'Is Not Bundle',
    id: 'LJQbnp',
    description: 'Filter Options Is Not Bundle',
  }),
};

export const productTypeFilterOptions = {
  standalone: defineMessage({
    defaultMessage: 'Standalone',
    id: 'OkDnZz',
    description: 'Filter Options Standalone Type',
  }),
  parent: defineMessage({
    defaultMessage: 'Parent',
    id: 'ofzk7I',
    description: 'Filter Options Parent Type',
  }),
};

export const alertFilterOptions = {
  noAlerts: defineMessage({
    defaultMessage: 'No Alerts',
    id: '+B1zww',
    description: 'Alert filter option, no alerts',
  }),
  reorderThresholdMet: defineMessage({
    defaultMessage: 'Reorder Threshold Met',
    id: 'mM0Khg',
    description: 'Alert filter option, reorder threshold met',
  }),
  noInventory: defineMessage({
    defaultMessage: 'No Inventory',
    id: 'Wv9P3r',
    description: 'Alert filter option, no inventory',
  }),
};

export const trackedFilterOptions = {
  tracked: defineMessage({
    defaultMessage: 'Tracked',
    id: 'AwbkeO',
    description: 'Tracked filter option, Tracked',
  }),
  notTracked: defineMessage({
    defaultMessage: 'Not Tracked',
    id: 'DOsWYw',
    description: 'Tracked filter option, Not Tracked',
  }),
};

export const autoSplitFilterOptions = {
  splitOnLineItem: defineMessage({
    description: 'Autosplit filter option, split product',
    defaultMessage: 'Split Product',
    id: 'io9oY6',
  }),
  splitOnQuantity: defineMessage({
    description: 'Autosplit filter option, split quantity',
    defaultMessage: 'Split Quantity',
    id: 'QBWY8r',
  }),
  splitOnCustomQuantity: defineMessage({
    description: 'Autosplit filter option, split on custom quantity',
    defaultMessage: 'Split Quantity ({customQty})',
    id: 'mw+F7P',
  }),
};

export default defineMessages({
  products: {
    defaultMessage: 'Products',
    id: '8un0tU',
    description: 'Product Left Nav Item',
  },
  presetGroups: {
    defaultMessage: 'Preset Groups',
    id: 'nXr8QR',
    description: 'PresetGroup Left Nav Item',
  },
  purchaseOrders: {
    defaultMessage: 'Purchase Orders',
    id: 'b0G5Ap',
    description: 'Purchase Orders Left Nav Item',
  },
  inventory: {
    defaultMessage: 'Inventory',
    id: '2AYkK4',
    description: 'Inventory Left Nav Item',
  },
  externalInventoryHeader: {
    defaultMessage: 'External Inventory / {inventoryName}',
    id: 'Sii3Ek',
    description: 'External Inventory grid header',
  },
  lastSynced: {
    defaultMessage: 'Last Synced:',
    id: 'PoaKNL',
    description: 'Date of last External Inventory sync',
  },
  externalinventory: {
    defaultMessage: 'External Inventory',
    id: 'd/UYyY',
    description: 'External Inventory Left Nav Item',
  },
  transferOrders: {
    defaultMessage: 'Transfer Orders',
    id: 'CJYu0c',
    description: 'Transfer Orders Left Nav Item',
  },
  allExternalInventory: {
    defaultMessage: 'All External Inventories',
    id: 'bRCPNQ',
    description: 'External Inventory Left Nav Item',
  },
  allWarehouses: {
    defaultMessage: 'All Warehouses',
    id: 'g0lzSf',
    description: 'Message when all warehouses are selected in the inventory grid',
  },
  reportingCategories: {
    defaultMessage: 'Reporting Categories',
    id: 'g17oF0',
    description: 'ReportingCategory Left Nav Item',
  },
  searchValue: {
    defaultMessage: 'Search Products...',
    id: 'cCx1xM',
    description: 'Product Left Nav QuickSearch Placeholder',
  },
  alertColumnHeader: {
    defaultMessage: 'Alert',
    id: 'mhLGnq',
    description: 'Inventory Grid Alert Column Header',
  },
  activeColumnHeader: {
    defaultMessage: 'Active',
    id: 'MTcERk',
    description: 'Product Grid Active Column Header',
  },
  bundleColumnHeader: {
    defaultMessage: 'Bundle',
    id: 'hrWhUm',
    description: 'Product Grid Bundle Column Header',
  },
  aliasColumnHeader: {
    defaultMessage: 'Alias',
    id: 'n1KSnU',
    description: 'Product Grid Alias Column Header',
  },
  allocatedColumnHeader: {
    defaultMessage: 'Allocated',
    id: 'kwHLuN',
    description: 'Product Grid Allocated Column Header',
  },
  availableColumnHeader: {
    defaultMessage: 'Available',
    id: 'JfdZ51',
    description: 'Product Grid Available Column Header',
  },
  activeShippingLocationsColumnHeader: {
    defaultMessage: 'Active Ship Froms',
    id: 'qbbjQ/',
    description: 'Product Grid Active Shipping Locations Column Header',
  },
  categoryIdColumnHeader: {
    defaultMessage: 'Reporting Category',
    id: '6arv11',
    description: 'Product Grid Category ID Column Header',
  },
  createDateUTCColumnHeader: {
    defaultMessage: 'Created At',
    id: 'ymrQex',
    description: 'Product Grid Created Column Header',
  },
  customsTariffNoColumnHeader: {
    defaultMessage: 'Harmonization Code',
    id: 'HRGvhF',
    description: 'Product Grid Customs Tariff No. Column Header',
  },
  dimensionsColumnHeader: {
    defaultMessage: 'Dimensions',
    id: 'mVj45X',
    description: 'Product Grid Dimensions Column Header',
  },
  fulfillmentSKUColumnHeader: {
    defaultMessage: 'Fulfillment SKU',
    id: 'yUufH+',
    description: 'Product Grid Fulfillment SKU Column Header',
  },
  parentSKUColumnHeader: {
    defaultMessage: 'Parent SKU',
    id: 'xXqKT5',
    description: 'Inventory Grid Parent SKU Column Header',
  },
  intlServiceIdColumnHeader: {
    defaultMessage: 'Mapped International',
    id: 'RhJj35',
    description: 'Product Grid Mapped International Column Header',
  },
  modifyDateUTCColumnHeader: {
    defaultMessage: 'Modified At',
    id: 'J/SVjJ',
    description: 'Product Grid Modified Column Header',
  },
  nameColumnHeader: {
    defaultMessage: 'Name',
    id: 'U3s/8F',
    description: 'Product Grid Name Column Header',
  },
  productProfileIdColumnHeader: {
    defaultMessage: 'Preset Group',
    id: '1j4zN5',
    description: 'Product Grid Preset Group Column Header',
  },
  productTypeColumnHeader: {
    defaultMessage: 'Product Type',
    id: 'XFdQsL',
    description: 'Product Grid Type Column Header',
  },
  productVariantIdsColumnHeader: {
    defaultMessage: 'Variants',
    id: 'M4qd3z',
    description: 'Product Grid Variants Column Header',
  },
  serviceIdColumnHeader: {
    defaultMessage: 'Mapped Domestic',
    id: 'UzVbR0',
    description: 'Product Grid Mapped Domestic Column Header',
  },
  skuColumnHeader: {
    defaultMessage: 'SKU',
    id: 'BKhNu3',
    description: 'Product Grid SKU Column Header',
  },
  connectionSkuColumnHeader: {
    defaultMessage: 'Connection SKU',
    id: 'aMU/P2',
    description: 'Product Grid Connection SKU Column Header',
  },
  connectionNameColumnHeader: {
    defaultMessage: 'Connection Name',
    id: 'IgxYCq',
    description: 'External Inventory Grid Connection Name Column Header',
  },
  stockColumnHeader: {
    defaultMessage: 'On Hand',
    id: 'Tum0sj',
    description: 'Product Grid On Hand Column Header',
  },
  inventoryColumnHeader: {
    defaultMessage: 'Inventory',
    id: 'VQUAol',
    description: 'Product Grid inventory Column Header',
  },
  tagsColumnHeader: {
    defaultMessage: 'Tags',
    id: '2smuDV',
    description: 'Product Grid Tags Column Header',
  },
  thumbnailUrlColumnHeader: {
    defaultMessage: 'Image',
    id: 'HFBmxi',
    description: 'Product Grid Image Column Header',
  },
  upcColumnHeader: {
    defaultMessage: 'UPC',
    id: 'dV0ZHR',
    description: 'Product Grid UPC Column Header',
  },
  warehouseLocationColumnHeader: {
    defaultMessage: 'Warehouse Location',
    id: '83/1oa',
    description: 'Product Grid Warehouse Location Column Header',
  },
  warehouseNameColumnHeader: {
    defaultMessage: 'Warehouse Name',
    id: 'gdBWIt',
    description: 'Inventory Grid Warehouse Name Column Header',
  },
  weightColumnHeader: {
    defaultMessage: 'Weight',
    id: '7kN/5p',
    description: 'Product Grid Weight Column Header',
  },
  declaredValueColumnHeader: {
    defaultMessage: 'Declared Value',
    id: '8kl5PE',
    description: 'Product Grid Declared Value Column Header',
  },
  priceColumnHeader: {
    defaultMessage: 'Price',
    id: 'm7mshr',
    description: 'Product Grid Price Column Header',
  },
  costColumnHeader: {
    defaultMessage: 'Cost',
    id: 'soQ62V',
    description: 'Product Grid Cost Column Header',
  },
  totalAvailableInventoryColumnHeader: {
    defaultMessage: 'In Stock',
    id: 'uigKdn',
    description: 'Product Grid In Stock from 3PLs',
  },
  newProductButton: {
    defaultMessage: 'New Product',
    id: 'PUiOXd',
    description: 'Product Grid Action Menu New Product',
  },
  categoryButton: {
    defaultMessage: 'Reporting Category',
    id: 'NDGn6/',
    description: 'Product Grid Action Button for Category',
  },
  tagButton: {
    defaultMessage: 'Tag',
    id: 'rlzIGg',
    description: 'Product Grid Action Button for Tag',
  },
  manageTags: {
    description: 'gridHeaderButtons.manageTags',
    defaultMessage: 'Manage Tags',
    id: 'OFoF6f',
  },
  combineButton: {
    defaultMessage: 'Combine',
    id: '3kHdJr',
    description: 'Product Grid Action Menu Combine',
  },
  productGridExportsButton: {
    description: 'Export products button',
    defaultMessage: 'Export',
    id: '9UZ0Dr',
  },
  productGridImportsButton: {
    description: 'Import products button',
    defaultMessage: 'Import',
    id: '/3gnGJ',
  },
  addToSupplierButton: {
    defaultMessage: 'Add to Supplier',
    id: 'gbAH/2',
    description: 'Product Grid Action Button for Add to Supplier',
  },
  importProductsOption: {
    description: 'Products Grid Actions Import Dropdown Option',
    defaultMessage: 'Import Products',
    id: 'DfWWLz',
  },
  filterBarShowInactive: {
    defaultMessage: 'Show Inactive Products',
    id: 'fDvBxg',
    description: 'Product Filter Bar Show Inactive Checkbox Label',
  },
  filterBarCategories: {
    defaultMessage: 'Categories',
    id: '9SLYGw',
    description: 'Product Filter Bar Categories Label',
  },
  filterBarCreated: {
    defaultMessage: 'Created',
    id: 'cwDFmE',
    description: 'Product Filter Bar Created Label',
  },
  filterBarModified: {
    defaultMessage: 'Modified',
    id: 'u1KJ8I',
    description: 'Product Filter Bar Modified Label',
  },
  neverModified: {
    description: 'filterOptions.neverModified',
    defaultMessage: 'Never Modified',
    id: 'g741E5',
  },
  trackedFilterLabel: {
    description: 'filteroptions.tracked',
    defaultMessage: 'Tracked',
    id: 'B/OcN+',
  },
  reorderThresholdColumnHeader: {
    description: 'Inventory grid, reorder threshold column header',
    defaultMessage: 'Reorder Threshold',
    id: 'RsAUsd',
  },
  reOrderThresholdMetTooltip: {
    description: 'Inventory grid, Alert Column, reorder threshold met tooltip',
    defaultMessage: 'Reordering threshold has been met',
    id: 'QM3LqD',
  },
  noAvailableStock: {
    description: 'Inventory grid, Alert Column, no available stock',
    defaultMessage: 'No Available Stock',
    id: 'XJmw6S',
  },
  actionsColumnHeader: {
    description: 'Inventory grid, actions column header',
    defaultMessage: 'Actions',
    id: 'CoO5uW',
  },
  auditColumnHeader: {
    description: 'Inventory grid, audit column header',
    defaultMessage: 'Audit',
    id: '/DwT29',
  },
  auditStatusAssigned: {
    description: 'Inventory grid, audit column, assigned status label',
    defaultMessage: 'Assigned',
    id: 'NuuQuQ',
  },
  auditStatusInProgress: {
    description: 'Inventory grid, audit column, in progress status label',
    defaultMessage: 'In Progress',
    id: 'PJqKnr',
  },
  auditStatusPaused: {
    description: 'Inventory grid, audit column, paused status label',
    defaultMessage: 'Paused',
    id: 'eiOEcb',
  },
  auditDueDateLabel: {
    description: 'Inventory grid, audit column, due date label with separator',
    defaultMessage: '- Due {dueDate}',
    id: 'nbOj2N',
  },
  auditEditModalTitle: {
    description: 'Title for the Audit Details modal when the audit is editable',
    defaultMessage: 'Edit Audit',
    id: 'RG45pM',
  },
  auditEditModalNotice: {
    description: 'Notice below the due date in the Edit Audit modal informing users about downstream changes',
    defaultMessage:
      'Changes will be applied to <b>{count}</b> SKUs sharing this audit. The audit is visible in the ShipStation mobile app.',
    id: 'NzccTy',
  },
  auditEditModalDeleteButton: {
    description: 'Delete Audit button label in the Edit Audit modal footer',
    defaultMessage: 'Delete audit',
    id: '2oAKnt',
  },
  auditCancelSuccess: {
    description: 'Notification title shown when a stock audit is deleted successfully',
    defaultMessage: 'Audit deleted',
    id: 'WqtxBA',
  },
  auditCancelError: {
    description: 'Notification title shown when deleting a stock audit fails',
    defaultMessage: 'Failed to delete audit',
    id: '0AfYsJ',
  },
  auditDetailsModalTitle: {
    description: 'Title for the Audit Details modal',
    defaultMessage: 'Audit Details',
    id: 'dJdC/o',
  },
  auditDetailsModalSaveButton: {
    description: 'Save button label in the Audit Details modal',
    defaultMessage: 'Save',
    id: 'Z+IN8k',
  },
  auditDetailsModalCloseButton: {
    description: 'Close button label in the Audit Details modal (read-only view)',
    defaultMessage: 'Close',
    id: 'igLlk2',
  },
  auditDetailsLoadError: {
    description: 'Notification shown when loading an audit details for the Audit Details modal fails',
    defaultMessage: 'Failed to load audit details',
    id: 'Zf2h/d',
  },
  auditInventoryLoadError: {
    description: 'Notification shown when loading inventory levels for audit products fails',
    defaultMessage: 'Failed to load inventory levels',
    id: 'Qe5hz2',
  },
  auditInventoryLoadErrorContent: {
    description: 'Content for notification when loading inventory levels for audit products fails',
    defaultMessage: 'On hand quantities may be inaccurate. Please try again.',
    id: '2myK6o',
  },
  deallocateButton: {
    description: 'actionMenu.deallocate',
    defaultMessage: 'Deallocate',
    id: 'JYXaZZ',
  },
  exportButton: {
    description: 'actionMenu.export',
    defaultMessage: 'Export',
    id: 'yCHWUu',
  },
  importButton: {
    description: 'actionMenu.import',
    defaultMessage: 'Import',
    id: 'ZAek0w',
  },
  moveButton: {
    id: 'FW1f8n',
    description: 'Move button label in inventory grid action buttons',
    defaultMessage: 'Move',
  },
  reorderButton: {
    description: 'Button label for the feature that helps a user order more inventory',
    defaultMessage: 'Reorder Assist',
    id: 'Io233f',
  },
  reorderButtonRootViewTooltip: {
    description: 'Tooltip for Reorder button on root inventory view',
    defaultMessage: 'Please select a specific warehouse to reorder stock',
    id: 'vkgSbM',
  },
  reorderButtonNoProductsTooltip: {
    description: 'Tooltip for Reorder button when no products are selected',
    defaultMessage: 'Select some products to reorder',
    id: 'lvTrcd',
  },
  reorderButtonNotEnabledTooltip: {
    description: 'Tooltip for Reorder button when feature is not enabled',
    defaultMessage: 'Upgrade your plan to access Reorder Assist and other advanced inventory features',
    id: 'Da4/b/',
  },
  activeShippingLocationsButton: {
    description: 'button label for bulk update of Active Shipping Locations from the Products Grid',
    defaultMessage: 'Active Ship Froms',
    id: 'p4YafG',
  },
  addPresetGroupButton: {
    description: 'button label for Add Preset Group in the Products Grid Header',
    defaultMessage: 'Add Preset Group',
    id: 'no4xDA',
  },
  inventoryTrackingDisabledWarning: {
    description: 'Inventory grid, tracking disabled',
    defaultMessage: 'Inventory tracking is not currently enabled... <a>Manage Settings</a>',
    id: 'vFgMTo',
  },
  deactivateButton: {
    description: 'Product Grid Header, Deactivate Button',
    defaultMessage: 'Deactivate',
    id: 'xB1KtI',
  },
  deactivateModalTitle: {
    description: 'Product Grid, Deactivate Modal Title',
    defaultMessage: 'Deactivate Products',
    id: 'gijs74',
  },
  confirm: {
    description: 'Deactivate Product Modal, Confirm Button',
    defaultMessage: 'Confirm',
    id: '2atP+m',
  },
  cancel: {
    description: 'Deactivate Product Modal, Cancel Button',
    defaultMessage: 'Cancel',
    id: 'FOdrke',
  },
  save: {
    description: 'Save Button',
    defaultMessage: 'Save',
    id: 'VJy4Al',
  },
  deactivateProductWarning: {
    description: 'Deactivate Product Modal, Warning Message',
    defaultMessage: 'Are you sure you want to deactivate the selected products?',
    id: 'DODoFp',
  },
  pluralAliases: {
    description: 'Product Grid Cell Text Highlighting Multiple Aliases exist',
    defaultMessage: '{ number } Aliases',
    id: '+X0DK3',
  },
  deleteProductButton: {
    defaultMessage: 'Delete',
    id: 'w1CZfu',
    description: 'Product Grid Action Menu Delete',
  },
  createPurchaseOrderButton: {
    description: 'button label for Create Purchase Order in the Products Grid Header',
    defaultMessage: 'Create Purchase Order',
    id: 'PBT++j',
  },
  auditUpdateSuccess: {
    description: 'Notification title shown when a stock audit is updated successfully',
    defaultMessage: 'Audit updated',
    id: 'kbzwaH',
  },
  auditUpdateError: {
    description: 'Notification title shown when updating a stock audit fails',
    defaultMessage: 'Failed to update audit',
    id: 'Dj5/bV',
  },
  deleteModalHeader: {
    description: 'Product Confirm Delete Modal Header',
    defaultMessage: 'Confirm Delete',
    id: 'W/HA5B',
  },
  deleteModalConfirmation: {
    description: 'Product Confirm Delete Modal Button',
    defaultMessage: 'Delete',
    id: 'Pfxenm',
  },
  deleteModalBodyTitle: {
    description: 'Product Confirm Delete Modal Body Title',
    defaultMessage: 'This action cannot be undone.',
    id: 'im530/',
  },
  deleteModalBodyText1: {
    description: 'Product Confirm Delete Modal Body Explanation 1',
    defaultMessage:
      'The Product data on the selected records will no longer be accessible. A deleted Product record will NOT display in search results or display in Inactive Products.',
    id: 'vrVpiu',
  },
  deleteModalBodyText2: {
    description: 'Product Confirm Delete Modal Body Explanation 2',
    defaultMessage: 'This record cannot be resurrected.',
    id: '4ygov/',
  },
  deleteModalBodyText3: {
    description: 'Product Confirm Delete Modal Body Explanation 3',
    defaultMessage:
      "The SKU will be able to be reused, but it will not inherit any of the previous product's data. If ShipStation receives this SKU as a line item a new Product record will be created, but without any of the previous product's data.",
    id: 'YQ3HoC',
  },
  aggregateLastUpdated: {
    description: 'Product Grid Cell Header Last Updated Tooltip info',
    defaultMessage: 'Last Updated:',
    id: 'vfqZz7',
  },
  availableInventoryTooltip: {
    description: 'Product Grid Cell Header Last Updated Tooltip Title',
    defaultMessage: 'Available Inventory',
    id: '11NRD2',
  },
  deleteProductErrorTitle: {
    description: 'Product Grid Delete Product Modal Title',
    defaultMessage: 'Failed to Delete Product',
    id: '4BQXFJ',
  },
  deleteProductErrorContent: {
    description: 'Product Grid Delete Product Modal Content',
    defaultMessage: 'An unexpected error occurred while deleting selected Products',
    id: 'KeL6LQ',
  },
  importLogModalTitle: {
    description: 'Product Grid Import Products Log Modal Title',
    defaultMessage: 'Product Import Results',
    id: '93D28Z',
  },
  importLogModaLContent: {
    description: 'Product Grid Import Products Log Modal Content',
    defaultMessage:
      "Your import has completed. Any warnings or errors that may have occurred are listed in the import results below. When you are finished reviewing the import results, click 'Close' to leave this window.",
    id: 'WVbc32',
  },
  combineProductErrorTitle: {
    description: 'Product Grid Combine Products Modal Title',
    defaultMessage: 'Failed To Combine Products',
    id: 'pFFsN6',
  },
  aggregateLastUpdatedAdditional: {
    description: 'In Stock column tooltip additional info.',
    defaultMessage: 'Inventory available for sale',
    id: 'xdVBiU',
  },
  aggregateLastUpdatedAdditionalWithSync: {
    description: 'In Stock column tooltip additional info for inventory sync',
    defaultMessage: 'Inventory available for sale. This number is synced to your selling channels with Inventory Sync.',
    id: 'idYWBg',
  },
  committedTooltipMessage: {
    description: 'Committed column tooltip additional info',
    defaultMessage: 'Inventory set aside for unfulfilled orders.',
    id: 'hDCdfY',
  },
  autoSplitColumnHeader: {
    description: 'Product Grid Autosplit Column Header',
    defaultMessage: 'Auto-split Option',
    id: 'aDMuOG',
  },
  autoSplitButton: {
    description: 'Product Grid AutoSplit Button from Action Menu',
    defaultMessage: 'Auto-split',
    id: 'hA04f/',
  },
  committedColumnHeader: {
    defaultMessage: 'Committed',
    id: 'jyk560',
    description: 'Product Grid Committed Column Header',
  },
  inboundColumnHeader: {
    id: 'azCL0V',
    defaultMessage: 'Inbound',
    description: 'Product Grid Inbound Column Header',
  },
  inboundTooltipMessage: {
    id: '6VmZzC',
    defaultMessage: "Units ordered in Purchase Orders and Transfer Orders in 'Open' or 'Receiving' status",
    description: 'Inbound column tooltip explaining what the value represents',
  },
  lowStockAlert: {
    description: 'Warning banner message for a product with low stock',
    defaultMessage: 'Low Stock Alert',
    id: 'BC/2ax',
  },
  criticalStockAlert: {
    description: 'Error banner message for a product with very low stock',
    defaultMessage: 'Critical Stock Alert',
    id: 'tThQdp',
  },
  onHandLabel: {
    description: 'List label for the product stock that is on hand and is currently in a warehouse',
    defaultMessage: 'On Hand:',
    id: '9p2ReM',
  },
  committedLabel: {
    description: 'List label for the product stock that is that is already associated with existing order and is committed to those orders',
    defaultMessage: 'Committed:',
    id: 'Cx2Znw',
  },
  inStockLabel: {
    description: 'List label for the product stock that is on hand and available for sale; in stock',
    defaultMessage: 'In Stock:',
    id: 'bADYPu',
  },
  reorderThresholdLabel: {
    description: 'List label for the product stock level that the seller wants to maintain before reordering more stock',
    defaultMessage: 'Reorder Threshold:',
    id: 'DdHhyE',
  },
  reorderThresholdNotSet: {
    description: 'Disclaimer for missing product value and how to configure the value in the Product Details menu',
    defaultMessage: '*Configure this in Product Details',
    id: 'TV7rfI',
  },
  scanToReceiveButton: {
    description: 'Button to open scan to receive functionality',
    defaultMessage: 'Receive Stock',
    id: '7gJxic',
  },
  scanToReceiveCompletedTitle: {
    description: 'Notification title when job is completed',
    defaultMessage: 'Product stocks updated',
    id: '5sbm4S',
  },
  scanToReceiveCompletedContent: {
    description: 'Notification content when job is completed',
    defaultMessage: 'Your inventory counts have been successfully updated.',
    id: 'SeeJiS',
  },
  scanToReceiveButtonDisabledTooltip: {
    description: 'Tooltip for Receive Stock button when feature is not enabled',
    defaultMessage: 'Upgrade your plan to access Receive Stock and other advanced inventory features',
    id: '3bIXCj',
  },
  externalInventorySearchTooShortTitle: {
    defaultMessage: 'Search term for External Inventory is too short',
    description: 'Search Term Too Short notification title',
    id: 'ssuW3t',
  },
  externalInventorySearchTooShortContent: {
    defaultMessage: 'To perform search on External Inventory search term should be at least 3 characters long',
    description: 'Search Term Too Short notification content',
    id: 'pcxFuu',
  },
  suppliers: {
    defaultMessage: 'Suppliers',
    id: 'X6rSnz',
    description: 'Suppliers Left Nav Item',
  },
});
